import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { IHeadband } from '../../../../../../models/headband.model';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../../../../services/alert.service';
import { DisplayHeadbandModeratorService } from '../../../../../../services/display-headband-moderator.service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';

@Component({
  selector: 'jhi-display-message-moderator-list',
  templateUrl: './display-message-moderator-list.component.html',
})
export class DisplayMessageModeratorListComponent {
  private readonly baryModalService = inject(BaryModalService);
  private readonly headbandService = inject(DisplayHeadbandModeratorService);
  private readonly translateService = inject(TranslateService);
  private readonly alertService = inject(AlertService);

  @Input() messages: IHeadband[] | undefined;
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;

  @Output() paginationChange = new EventEmitter<Pagination>();

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  trackId(index: number, item: IHeadband): number {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    return item.id!;
  }

  addToHeadband(headband?: IHeadband): void {
    this.baryModalService
      .openAddOrUpdateHeadband(headband)
      .action()
      .subscribe(() => {
        this.transition();
      });
  }

  deleteHeadband(headband?: IHeadband): void {
    const message = this.translateService.instant('headband.delete.question');
    this.baryModalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.headbandService.delete(headband?.id!).subscribe(
            () => {
              const successMessage = this.translateService.instant('headband.deleted');
              this.alertService.addAlert({ message: successMessage, type: 'success' });
              this.transition();
            },
            e => {
              console.error(e);
              const successMessage = this.translateService.instant('headband.delete.error');
              this.alertService.addAlert({ message: successMessage, type: 'danger' });
            }
          );
        }
      });
  }
}
